module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "title-page"
  }, [_vm._v(_vm._s(_vm.tituloDaPagina))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-26100638", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26100638"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CabecalhoDoConteudo.vue
// module id = 1099
// module chunks = 1